import request from '@/util/request'


export const capaHoldRequest = (data) => request.post('/api/capaLists', data);  //暂缓的CAPA请求

export const capaStartInvestigation = (data) => request.post('/api/CapaStartInvestigation', data);  //暂缓CAPA请求启动调查

